import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';

const GET_AVAILABLE_WEBHOOK_EVENTS = graphql(`
  query GetAvailableWebhookEvents {
    availableWebhookEvents {
      name
      description
    }
  }
`);

const useGetAvailableWebhookEvents = () => {
  return useQuery({
    staleTime: Infinity,
    queryKey: ['availableWebhookEvents'],
    queryFn: () => {
      return gqlClient.request(GET_AVAILABLE_WEBHOOK_EVENTS);
    },
  });
};

export default useGetAvailableWebhookEvents;
